import { createLazyReactDirective } from '../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./UnitInfoContainer')).UnitInfoContainer,
  'unitInfoContainer',
  {
    routeParams: '=',
  },
);
